const featureFlags = {
  get hideCallIndicator() {
    return !!window.__amp_feature_flags.hide_call_indicator;
  },
  get customerSituation() {
    return !!window.__amp_feature_flags.customer_situation;
  },
  get guidedServiceFlow() {
    return !!window.__amp_feature_flags.guided_service_flow;
  },
  get dynamicTips() {
    return (
      !!window.__amp_feature_flags.dynamic_tip_on_summary ||
      !!window.__amp_feature_flags.dynamic_tip_on_data_collection ||
      !!window.__amp_feature_flags.dynamic_tip_on_quotes ||
      !!window.__amp_feature_flags.life_insurance_pitch
    );
  },
  get dynamicTipOnSummary() {
    return !!window.__amp_feature_flags.dynamic_tip_on_summary;
  },
  get dynamicTipOnDataCollection() {
    return !!window.__amp_feature_flags.dynamic_tip_on_data_collection;
  },
  get dynamicTipOnQuotes() {
    return !!window.__amp_feature_flags.dynamic_tip_on_quotes;
  },
  get lifeInsurancePitch() {
    return !!window.__amp_feature_flags.life_insurance_pitch;
  },
  get cstGuidedSellingExperience() {
    return !!window.__amp_feature_flags.cst_guided_selling_experience;
  },
  get sendDocuments() {
    return !!window.__amp_feature_flags.send_documents;
  },
  get customerAssetsAddHome() {
    return !!window.__amp_feature_flags.customer_assets_add_home;
  },
  get disableOldLeadPolicyActions() {
    return !!window.__amp_feature_flags.disable_old_lead_policy_actions;
  },
  get carrierCapabilitiesCheck() {
    return !!window.__amp_feature_flags.carrier_capabilities_check;
  },
  get documentArchiving() {
    return !!window.__amp_feature_flags.document_archiving;
  }
};

export default featureFlags;
